export type SSOQueryResult = {
  sso: {
    nonce: string;
    state: string;
    url: string;
    realm: string;
    clientId: string;
    baseUrl: string;
  };
};

export interface IDToken {
  nonce: string;
  [key: string]: any;
}

export enum SocialLoginProvider {
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE'
}
